import { Property } from '@propertypal/shared/src/types/property';
import { SuperFeatureProperty } from '@propertypal/shared/src/types/superFeature';
import AboutPropertyNews from '@propertypal/web-ui/src/home/AboutPropertyNews';
import HomeHeader from '@propertypal/web-ui/src/home/HomeHeader';
import TopPicks from '@propertypal/web-ui/src/home/TopPicks';
import { Box } from '@propertypal/web-ui/src/layout';
import { MAX_WIDTH } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import React, { FunctionComponent } from 'react';

interface Props {
  superfeatures: SuperFeatureProperty[];
  popular: Property[];
  loggedIn: boolean;
  cfIpCountry: string | null;
}

const HomePage: FunctionComponent<Props> = (props) => {
  return (
    <>
      <HomeHeader superfeatures={props.superfeatures} loggedIn={props.loggedIn} cfIpCountry={props.cfIpCountry} />

      <TopPicks properties={props.popular} />

      <Box maxWidth={MAX_WIDTH - 20} style={{ margin: '0 auto' }}>
        <AboutPropertyNews />
      </Box>
    </>
  );
};

export default HomePage;
